// src/context/EstiloContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const defaultEstilos = {
    headerColor: '#ffffff',
    textoColor: '#111827',
    logoUrl: '',
};

const EstiloContext = createContext();

export const useEstilos = () => useContext(EstiloContext);

export const EstiloProvider = ({ children }) => {
    const [estilos, setEstilos] = useState(defaultEstilos);

    useEffect(() => {
        const local = localStorage.getItem('estilos');
        if (local) setEstilos(JSON.parse(local));
    }, []);

    const actualizarEstilos = (nuevos) => {
        const actualizados = { ...estilos, ...nuevos };
        setEstilos(actualizados);
        localStorage.setItem('estilos', JSON.stringify(actualizados));
    };

    return (
        <EstiloContext.Provider value={{ estilos, actualizarEstilos }}>
            {children}
        </EstiloContext.Provider>
    );
};
